'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminActualitesController', ['$scope', '$http', '$timeout', '$sce', 'Auth',
function($scope, $http, $timeout, $sce, Auth) {

  var API = '/api/actualites';

  /* ── état ─────────────────────────────────────────────────── */
  var rawData           = [];
  var allItems          = [];
  $scope.items          = [];
  $scope.categories     = [];
  $scope.isLoading      = true;
  $scope.showModal      = false;
  $scope.saving         = false;
  $scope.successMsg     = '';
  $scope.errorMsg       = '';
  $scope.searchQuery    = '';
  $scope.filterCategory = '';
  $scope.filterStatus   = '';
  $scope.currentPage    = 1;
  $scope.itemsPerPage   = 10;
  $scope.totalItems     = 0;
  $scope.totalPages     = 1;
  $scope.editing        = {};
  $scope.confirmDelete  = null;

  /* ── helpers ──────────────────────────────────────────────── */
  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  function paginate() {
    var size = parseInt($scope.itemsPerPage, 10) || 10;
    $scope.totalItems = allItems.length;
    $scope.totalPages = Math.ceil(allItems.length / size) || 1;
    if ($scope.currentPage > $scope.totalPages) { $scope.currentPage = 1; }
    var start = ($scope.currentPage - 1) * size;
    $scope.items = allItems.slice(start, start + size);
  }

  function applyFilters() {
    var q   = ($scope.searchQuery    || '').toLowerCase().trim();
    var cat = ($scope.filterCategory || '').trim();
    var st  = ($scope.filterStatus   || '').trim();
    allItems = rawData.filter(function(a) {
      var matchQ   = !q   || (a.titre || '').toLowerCase().indexOf(q) !== -1
                          || (a.resume || '').toLowerCase().indexOf(q) !== -1;
      var matchCat = !cat || (a.categories && a.categories.some(function(c) {
        return String(c.id) === cat;
      }));
      var matchSt  = !st  || (st === 'published' ? !!a.publie : !a.publie);
      return matchQ && matchCat && matchSt;
    });
    $scope.currentPage = 1;
    paginate();
  }

  /* ── pagination ───────────────────────────────────────────── */
  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) { return; }
    $scope.currentPage = p;
    paginate();
  };

  $scope.getPages = function() {
    var pages = [], n = $scope.totalPages, c = $scope.currentPage;
    var start = Math.max(1, c - 2), end = Math.min(n, c + 2);
    for (var i = start; i <= end; i++) { pages.push(i); }
    return pages;
  };

  $scope.onSearch   = function() { applyFilters(); };
  $scope.onFilter   = function() { applyFilters(); };

  /* ── chargement ───────────────────────────────────────────── */
  function loadCategories() {
    $http.get(API + '/categories').then(function(r) {
      $scope.categories = r.data || [];
    }).catch(angular.noop);
  }

  $scope.load = function() {
    $scope.isLoading = true;
    $http.get(API + '/admin', { params: { page: 0, size: 500 } })
      .then(function(r) {
        var data = r.data;
        rawData = Array.isArray(data) ? data : (data.content || []);
        applyFilters();
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des actualités.'); })
      .finally(function() { $scope.isLoading = false; });
  };

  /* ── catégorie inline ──────────────────────────────────── */
  $scope.showNewCategoryForm = false;
  $scope.catForm             = { name: '' };
  $scope.savingCategory      = false;

  $scope.toggleNewCategoryForm = function() {
    $scope.showNewCategoryForm = !$scope.showNewCategoryForm;
    $scope.catForm.name        = '';
  };

  $scope.addCategory = function() {
    var name = ($scope.catForm.name || '').trim();
    if (!name) { return; }
    $scope.savingCategory = true;
    $http.post(API + '/categories', { name: name })
      .then(function(res) {
        var cat = res.data;
        if (!$scope.categories.some(function(c) { return c.id === cat.id; })) {
          $scope.categories.push({ id: cat.id, name: cat.name });
        }
        $scope.editing.categoryId  = cat.id;
        $scope.showNewCategoryForm = false;
        $scope.catForm.name        = '';
      })
      .catch(function(err) {
        flash('errorMsg', (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de la création.');
      })
      .finally(function() { $scope.savingCategory = false; });
  };

  /* ── image upload ────────────────────────────────────────── */
  $scope.imageDragOver  = false;
  $scope.imageUploading = false;

  $scope.triggerImageInput = function() {
    var input = document.getElementById('imageFileInput');
    if (input) { input.value = ''; input.click(); }
  };

  $scope.onImageDrop = function(event) {
    var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
    $timeout(function() {
      $scope.imageDragOver = false;
      if (file) { $scope.uploadImageFile(file); }
    });
  };

  $scope.onImageFileSelected = function(input) {
    var file = input.files && input.files[0];
    if (file) {
      $timeout(function() { $scope.uploadImageFile(file); });
    }
  };

  $scope.uploadImageFile = function(file) {
    $scope.imageUploading = true;
    var fd = new FormData();
    fd.append('file', file);
    $http.post('/api/upload/image', fd, {
      headers: { 'Content-Type': undefined },
      transformRequest: angular.identity
    }).then(function(res) {
      $scope.editing.imageUrl = res.data.url;
    }).catch(function(err) {
      flash('errorMsg', (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de l\'upload de l\'image.');
    }).finally(function() { $scope.imageUploading = false; });
  };

  /* ── rich editor ─────────────────────────────────────────── */
  function initEditor(html) {
    $timeout(function() {
      var el = document.getElementById('actualiteRichEditor');
      if (el) { el.innerHTML = html || ''; }
    }, 60);
  }

  $scope.execFormat = function(cmd, val) {
    document.execCommand(cmd, false, val !== undefined ? val : null);
    var el = document.getElementById('actualiteRichEditor');
    if (el) { el.focus(); $scope.editing.content = el.innerHTML; }
  };

  $scope.insertLink = function() {
    var url = prompt('URL du lien :');
    if (url) {
      document.execCommand('createLink', false, url);
      var el = document.getElementById('actualiteRichEditor');
      if (el) { $scope.editing.content = el.innerHTML; }
    }
  };

  $scope.onEditorInput = function() {
    var el = document.getElementById('actualiteRichEditor');
    if (el) { $scope.editing.content = el.innerHTML; }
  };

  $scope.safeHtml = function(html) {
    return $sce.trustAsHtml(html || '');
  };

  /* ── modal ────────────────────────────────────────────────── */
  $scope.openNew = function() {
    $scope.editing = { published: false, dateObj: null };
    $scope.showNewCategoryForm = false;
    $scope.catForm.name        = '';
    $scope.showModal = true;
    initEditor('');
  };

  $scope.openEdit = function(item) {
    var cats = item.categories || [];
    $scope.editing = {
      id:         item.id,
      title:      item.titre,
      summary:    item.resume,
      content:    item.contenu,
      imageUrl:   item.imageUrl,
      published:  item.publie,
      categoryId: cats.length > 0 ? cats[0].id : null
    };
    var d = item.publishedAt || item.createdAt;
    var dateObj = null;
    if (Array.isArray(d)) {
      dateObj = new Date(d[0], d[1] - 1, d[2]);
    } else if (d) {
      var parsed = new Date(d);
      dateObj = isNaN(parsed.getTime()) ? null : parsed;
    }
    $scope.editing.dateObj = dateObj;
    $scope.showNewCategoryForm = false;
    $scope.catForm.name        = '';
    $scope.showModal = true;
    initEditor($scope.editing.content);
  };

  $scope.closeModal = function() {
    $scope.showModal           = false;
    $scope.editing             = {};
    $scope.errorMsg            = '';
    $scope.showNewCategoryForm = false;
    $scope.catForm.name        = '';
  };

  /* ── sauvegarde ───────────────────────────────────────────── */
  $scope.save = function() {
    if (!$scope.editing.title) { flash('errorMsg', 'Le titre est obligatoire.'); return; }
    $scope.saving = true;
    var isNew = !$scope.editing.id;
    var payload = {
      titre:      $scope.editing.title,
      resume:     $scope.editing.summary    || '',
      contenu:    $scope.editing.content    || '',
      imageUrl:   $scope.editing.imageUrl   || null,
      publie:     !!$scope.editing.published,
      categories: $scope.editing.categoryId ? [{ id: $scope.editing.categoryId }] : [],
      auteur:     $scope.user ? { id: $scope.user.id, username: $scope.user.username } : null
    };
    var req = isNew
      ? $http.post(API, payload)
      : $http.put(API + '/' + $scope.editing.id, payload);

    req.then(function() {
      $scope.closeModal();
      $scope.load();
      flash('successMsg', isNew ? 'Actualité créée.' : 'Actualité mise à jour.');
    }).catch(function(err) {
      flash('errorMsg', (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de l\'enregistrement.');
    }).finally(function() { $scope.saving = false; });
  };

  /* ── suppression ──────────────────────────────────────────── */
  $scope.askDelete   = function(item) { $scope.confirmDelete = item; };
  $scope.cancelDelete = function()    { $scope.confirmDelete = null; };

  $scope.doDelete = function() {
    if (!$scope.confirmDelete) { return; }
    var id = $scope.confirmDelete.id;
    $scope.confirmDelete = null;
    $http.delete(API + '/' + id)
      .then(function() { $scope.load(); flash('successMsg', 'Actualité supprimée.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  /* ── utilitaires ──────────────────────────────────────────── */
  $scope.formatDate = function(d) {
    if (!d) { return '—'; }
    var dt;
    if (Array.isArray(d)) {
      dt = new Date(d[0], d[1] - 1, d[2]);
    } else {
      dt = new Date(d);
      if (isNaN(dt.getTime())) { return '—'; }
    }
    return dt.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  /* ── init ─────────────────────────────────────────────────── */
  Auth.identity().then(function(user) {
    $scope.user = user;
    $scope.load();
    loadCategories();
  });

}]);
